import { IS_TEST_DATA_LOADED } from '../constants/actionTypes'

export default (state = { isTestDataLoaded: false }, action) => {
    switch (action.type) {
        case IS_TEST_DATA_LOADED:
            return {
                ...state,
                isTestDataLoaded: action.payload,
            }
        default:
            return state
    }
}
